import * as React from 'react'
import { Row, Message } from 'rsuite'
import SaveButton from '../components/buttons/saveButton/SaveButton'
import EditButton from '../components/buttons/editButton/EditButton'
import CancelButton from '../components/buttons/cancelButton/CancelButton'

export default function ButtonPanel(props) {
  const { buttonText, onSave, onCancel, onEdit, isDisabled, isEdit, isError } = props

  return (
    <>
      {isEdit ? (
        <div>
          {isError && (
            <Row style={{ marginBottom: 10 }}>
              <Message
                showIcon
                type="error"
                description={`เกิดข้อผิดพลาดในการบันทึก${
                  buttonText || ''
                } กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
              />
            </Row>
          )}
          <SaveButton disabled={isDisabled} onClick={onSave}>{`บันทึก${
            buttonText || ''
          }`}</SaveButton>
          <CancelButton onClick={onCancel}>{`ยกเลิก${buttonText || ''}`}</CancelButton>
        </div>
      ) : (
        <EditButton onClick={onEdit}>{`แก้ไข${buttonText || ''}`}</EditButton>
      )}
    </>
  )
}
